"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PrimaryPopupContent = void 0;

var _react = _interopRequireDefault(require("react"));

var _getClassesPropType = require("../../helpers/getClassesPropType");

var _useStyles = require("../../helpers/useStyles");

var _propTypes = require("prop-types");

var _loadStyles = _interopRequireDefault(require("load-styles"));

(0, _loadStyles.default)(".cb41aedec{font-size:1rem;font-weight:400;line-height:1.5rem;color:var(--color-flomni-gray-90)}");
var styles = {
  root: 'cb41aedec'
};

var PrimaryPopupContent = function PrimaryPopupContent(props) {
  var classes = props.classes,
      children = props.children;
  var cn = (0, _useStyles.useStyles)(styles, classes);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: cn.root
  }, children);
};

exports.PrimaryPopupContent = PrimaryPopupContent;
PrimaryPopupContent.propTypes = {
  /* component logic props */
  children: _propTypes.node.isRequired,

  /* classes */
  classes: (0, _getClassesPropType.getClassesPropType)(styles)
};
PrimaryPopupContent.defaultProps = {
  classes: {}
};